import styled from '@emotion/styled'

import {
  Space,
  TradeApprove,
  Typography,
  ValidationMessage
} from '../../../../../components/core-v2'
import TradeApproveReadonly from '../../../../../components/core-v2/molecules/trade-approve-readonly'
import TradeDocuments from '../../../../../components/core-v2/organisms/trade-documents'
import TradeEventDisplay from '../../../../../components/core-v2/organisms/trade-event-display/trade-event-display'
import { DESCRIPTIONS } from '../../../constants'
import { TradeApproveStepState } from '../state/trade-approve-slice'

export type TradeApproveStatelessProps = {
  onTradeApproved: (comments: string) => void
  onTradeReject: (comments: string) => void
  state: TradeApproveStepState
}

const StyledDownloadWrapper = styled.div`
  div {
    background: var(--White);
  }
`

const TradeApproveStateless = ({
  onTradeApproved,
  onTradeReject,
  state
}: TradeApproveStatelessProps) => {
  const { errors } = state
  const isEditable =
    state.userType === 'admin' || (state.userType === 'absa' && state.userRoles.includes('Trading'))

  const renderCompletedState = () => (
    <Space>
      {state.approvalEvents.map(approvalEvent => (
        <TradeEventDisplay key={approvalEvent.userId} {...approvalEvent} />
      ))}
    </Space>
  )

  const renderPendingState = () => (
    <>
      <Space my={6}>
        <Space mb={5}>
          <Typography variant="b3">{DESCRIPTIONS.TRADE_DOCUMENTS_APPROVE}</Typography>
        </Space>
        <StyledDownloadWrapper>
          <TradeDocuments tradeDocumentationUrl={state.tradeDocumentationUrl} />
        </StyledDownloadWrapper>
      </Space>
      <Space mt={5}>
        <ValidationMessage errors={errors} />
      </Space>
      <TradeApprove
        allowComments
        canApprove
        approveBtnCaption="Approve"
        approvingSection="trade"
        userName={state.userName}
        onApprove={onTradeApproved}
        onReject={onTradeReject}
      />
    </>
  )

  const renderReadOnly = () => (
    <Space my={6}>
      <TradeApproveReadonly waitingDescription="This trade is currently pending approval. Please check back later" />
    </Space>
  )

  return (
    <>
      {state.hasCompleted && renderCompletedState()}
      {!state.hasCompleted && isEditable && renderPendingState()}
      {!state.hasCompleted && !isEditable && renderReadOnly()}
    </>
  )
}

export default TradeApproveStateless
